import React from 'react';
import Drawer from 'rc-drawer';
import { observer } from 'mobx-react';
import { store } from '../../store';
import { Link } from "react-router-dom";
import * as URL from '../../router/url';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";

const DrawerMobile = observer(() =>  {
    const location = useLocation();
    const { pathname } = location;

    return (
        <Drawer 
            className='hide-lg'
            width="60vw" 
            open={ store.isDrawerOpen } 
            onClose={ () => store.setIsDrawerOpen() }
            onHandleClick={ () => store.setIsDrawerOpen() }
        >
            <div className='drawer-menu'>
                <Link to={ URL.ROOT } onClick={ () => store.setIsDrawerOpen() }>
                    <div className='header-desktop-icon-drawer'></div>
                </Link>
                <nav className='header-desktop-nav-drawer'>
                    <Link to={ URL.ROOT } onClick={ () => store.setIsDrawerOpen() }>
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname === URL.ROOT }) }>Главная</div>
                    </Link>
                    <Link to={ URL.COMMISSIONING_WORKS } onClick={ () => store.setIsDrawerOpen() }>
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname === URL.COMMISSIONING_WORKS }) }>Пусконаладочные <br/>работы</div>
                    </Link>
                    <Link to={ URL.AUTOMATION } onClick={ () => store.setIsDrawerOpen() }>
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname === URL.AUTOMATION }) }>Автоматизация</div>
                    </Link>
                    <Link to={ URL.ABOUT } onClick={ () => store.setIsDrawerOpen() }>   
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname === URL.ABOUT }) }>О компании</div>
                    </Link>
                    <Link to={ URL.PROJECTS } onClick={ () => store.setIsDrawerOpen() }>   
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname?.split('/')[1] === URL.PROJECTS.split('/')[1] }) }>Проекты</div>
                    </Link>
                    <Link to={ URL.VACANCIES } onClick={ () => store.setIsDrawerOpen() }>   
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname?.split('/')[1] === URL.VACANCIES.split('/')[1] }) }>Вакансии</div>
                    </Link>
                    <Link to={ URL.CONTACTS } onClick={ () => store.setIsDrawerOpen() }>   
                        <div className={ classNames('header-desktop-nav-item-drawer', { current: pathname === URL.CONTACTS }) }>Контакты</div>
                    </Link>
                </nav>
            </div>
        </Drawer>            
    )
})

export default DrawerMobile;